import {
  SectionHeaderStyle,
  HeaderRowStyle,
  DataRowStyle,
  DataRowBoldStyle,
  TextRowStyle,
  DataBorderTopLineDoubleBottomLineStyle,
  DataBorderDoubleBottomLineStyle,
  DataBorderTopLineStyle,
  ParentDataRowStyle,
  ParentSummary,
  ParentSummaryDouble,
} from '../constants/styles';

import {
  DATA,
  SECTION_HEADER,
  COLUMN_HEADER,
  PARENT_DATA,
  CHILD_DATA,
  CHILD_DATA_BOLD,
  PARENT_SUMMARY,
  PARENT_SUMMARY_DOUBLE,
  DATA_BORDER_TOPLINE,
  DATA_BORDER_DOUBLEBOTTOMLINE,
  DATA_BORDER_TOPLINE_DOUBLE_BOTTOMLINE,
  TEXT,
} from '../constants/rowTypes';

import numberFormatBuilder from './numberFormatBuilder';

const rowTypeToRowStyle = (rowType, { hideDecimals, shouldDisplayZero, negativeMinus }) =>
  ({
    [SECTION_HEADER]: SectionHeaderStyle,
    [COLUMN_HEADER]: HeaderRowStyle,
    [DATA]: {
      ...DataRowStyle,
      numFmt: numberFormatBuilder({ hideDecimals, shouldDisplayZero, negativeMinus }),
    },
    [CHILD_DATA]: {
      ...DataRowStyle,
      numFmt: numberFormatBuilder({ hideDecimals, shouldDisplayZero, negativeMinus }),
    },
    [CHILD_DATA_BOLD]: {
      ...DataRowBoldStyle,
      numFmt: numberFormatBuilder({ hideDecimals, shouldDisplayZero, negativeMinus }),
    },
    [DATA_BORDER_TOPLINE]: {
      ...DataBorderTopLineStyle,
      numFmt: numberFormatBuilder({ hideDecimals, shouldDisplayZero, negativeMinus }),
    },
    [DATA_BORDER_DOUBLEBOTTOMLINE]: {
      ...DataBorderDoubleBottomLineStyle,
      numFmt: numberFormatBuilder({ hideDecimals, shouldDisplayZero, negativeMinus }),
    },
    [DATA_BORDER_TOPLINE_DOUBLE_BOTTOMLINE]: {
      ...DataBorderTopLineDoubleBottomLineStyle,
      numFmt: numberFormatBuilder({ hideDecimals, shouldDisplayZero, negativeMinus }),
    },
    [PARENT_DATA]: {
      ...ParentDataRowStyle,
      numFmt: numberFormatBuilder({ hideDecimals, shouldDisplayZero, negativeMinus }),
    },
    [PARENT_SUMMARY]: {
      ...ParentSummary,
      numFmt: numberFormatBuilder({ hideDecimals, shouldDisplayZero, negativeMinus }),
    },
    [PARENT_SUMMARY_DOUBLE]: {
      ...ParentSummaryDouble,
      numFmt: numberFormatBuilder({ hideDecimals, shouldDisplayZero, negativeMinus }),
    },
    [TEXT]: TextRowStyle,
  }[rowType] || {});

export default rowTypeToRowStyle;
